// services/location/LocationObserver.ts
type UrlChangeCallback = (url: string) => void

export class LocationObserver {
  private readonly callbacks: UrlChangeCallback[] = []
  private currentUrl?: string

  constructor() {
    if (typeof window === 'undefined') return
    this.currentUrl = window.location.href
  }

  init(): void {
    window.addEventListener('popstate', this.handleUrlChange.bind(this))
  }

  registerCallback(callback: UrlChangeCallback): void {
    this.callbacks.push(callback)
  }

  private handleUrlChange(): void {
    const newUrl = window.location.href
    if (newUrl !== this.currentUrl) {
      this.currentUrl = newUrl
      this.callbacks.forEach((callback) => callback(newUrl))
    }
  }

  cleanup(): void {
    window.removeEventListener('popstate', this.handleUrlChange.bind(this))
  }
}
